import {
  findNodePath,
  PlateRenderNodeProps,
  TRenderElementProps,
} from '@udecode/plate';
import React, { useCallback } from 'react';
import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import {
  EditorTooltip,
  TooltipButton,
  TooltipText,
} from '~/editor/components/EditorTooltip';
import { LinkElement } from '../nodes/LinkElement';
import { toggleShortening } from '../transforms/toggleShortening';
import { Wrapper } from './styles';

type LinkElementUIProps = PlateRenderNodeProps<BufferValue, BufferEditor> &
  TRenderElementProps<BufferValue, LinkElement>;

export const LinkElementUI = (props: LinkElementUIProps) => {
  const { attributes, children, element, editor } = props;

  const path = findNodePath(editor, element);
  const shortenLabel = element.isShortened ? 'Unshorten' : 'Shorten';
  const toggleLinkShortened = () =>
    path && toggleShortening(editor, [element, path]);

  const href = LinkElement.getHref(element);
  const onOpenClick = useCallback(() => {
    window.open(href, '_blank');
  }, [href]);

  return (
    <Wrapper
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...attributes}
    >
      <EditorTooltip trigger={<span>{children}</span>}>
        {LinkElement.canBeUnshortened(element) && (
          <TooltipText title={element.url}>{element.url}</TooltipText>
        )}
        <TooltipButton onClick={onOpenClick}>Open Link</TooltipButton>
        {/*
         * This link UI does support toggling back to short URL,
         * but the current composer architecture would require changes
         * for a few edge cases.
         * As a temporary measure, unshortening is only allowed once which
         * matches the existing feature in DraftJS editor.
         */}
        {LinkElement.canBeUnshortened(element) && (
          <TooltipButton onClick={toggleLinkShortened}>
            {shortenLabel}
          </TooltipButton>
        )}
      </EditorTooltip>
    </Wrapper>
  );
};
